import React from 'react';

function ChannelSplit({ channel }) {
  if (!channel) return null;
  return (
    <div className="inv-kpi-channel">
      <div className="inv-kpi-ch-row">
        <span className="inv-ch-badge online">🌐 Online</span>
        <span className="inv-ch-val">{channel.online_fmt}</span>
        {channel.online_pct != null && (
          <span className="inv-ch-pct">{channel.online_pct}%</span>
        )}
      </div>
      <div className="inv-kpi-ch-row">
        <span className="inv-ch-badge pos">🏪 POS</span>
        <span className="inv-ch-val">{channel.pos_fmt}</span>
        {channel.pos_pct != null && (
          <span className="inv-ch-pct">{channel.pos_pct}%</span>
        )}
      </div>
    </div>
  );
}

export default function KPICards({ kpis, channelSummary }) {
  return (
    <div className="inv-kpi-section">
      {channelSummary && (
        <div className="inv-channel-banner">
          <div className="inv-ch-banner-item online">
            <span className="inv-ch-banner-icon">🌐</span>
            <div className="inv-ch-banner-info">
              <span className="inv-ch-banner-label">Online Store</span>
              <span className="inv-ch-banner-rev">AED {channelSummary.online.revenue.toLocaleString()}</span>
              <span className="inv-ch-banner-meta">{channelSummary.online.orders} orders · {channelSummary.online.pct}%</span>
            </div>
          </div>
          <div className="inv-ch-banner-divider">
            <div className="inv-ch-progress">
              <div className="inv-ch-bar online" style={{ width: `${channelSummary.online.pct}%` }}></div>
              <div className="inv-ch-bar pos" style={{ width: `${channelSummary.pos.pct}%` }}></div>
            </div>
            <span className="inv-ch-vs">vs</span>
          </div>
          <div className="inv-ch-banner-item pos">
            <span className="inv-ch-banner-icon">🏪</span>
            <div className="inv-ch-banner-info">
              <span className="inv-ch-banner-label">Point of Sale</span>
              <span className="inv-ch-banner-rev">AED {channelSummary.pos.revenue.toLocaleString()}</span>
              <span className="inv-ch-banner-meta">{channelSummary.pos.orders} orders · {channelSummary.pos.pct}%</span>
            </div>
          </div>
        </div>
      )}
      <div className="inv-kpi-strip">
        {kpis.map((kpi, i) => (
          <div key={i} className="inv-kpi-card" style={{ '--kpi-color': kpi.color }}>
            <div className="inv-kpi-icon">{kpi.icon}</div>
            <div className="inv-kpi-info">
              <span className="inv-kpi-label">{kpi.label}</span>
              <span className="inv-kpi-value">{kpi.formatted}</span>
              {kpi.pct !== undefined && (
                <span className={`inv-kpi-pct ${kpi.pct > 15 ? 'danger' : kpi.pct > 5 ? 'warning' : 'ok'}`}>
                  {kpi.pct.toFixed(1)}% of inventory
                </span>
              )}
              <ChannelSplit channel={kpi.channel} />
            </div>
            <div className="inv-kpi-glow" style={{ background: kpi.color }}></div>
          </div>
        ))}
      </div>
    </div>
  );
}
